export default __webpack_public_path__ + "static/media/ic_alert.f151cf40.svg";